
import { useRef, useState } from 'react';
import BlogTypes from '../views/blogs/BlogTypes';
import BlogArticles from '../views/blogs/BlogArticles';
import Header from '../components/common/Header';

function Blog() {
  const [selectedType, setSelectedType] = useState<string>('All');
  const blogTypesRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(1);

  return (
    <>
      <Header
        pillLabel="Blogs"
        title="Unleashing Infinite Curiosity: Explore, Learn, Thrive"
        description="Embark on a journey of discovery with our blog, where knowledge knows no bounds. Dive into a world of insightful articles, engaging stories, and valuable insights that fuel your curiosity."
        image="blog_background.svg"
        renderButton
        buttonText="Check My Software"
      />
      <div ref={blogTypesRef}></div>
      <BlogTypes
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        page={page}
        setPage={setPage}
      />
      <BlogArticles selectedType={selectedType}
        scrollTargetRef={blogTypesRef}
        page={page}
        setPage={setPage}
      />
    </>
  );
}

export default Blog;